import { layerExists, sourceExists, toggleLayerIfRequired } from '../_helpers';

let mapReference;

const addLayersIfRequired = () => {
  // Find the id of the first text layer in the map style to insert the new layer under it
  const layers = mapReference.getStyle().layers;
  let firstSymbolId;
  for (const layer of layers) {
    if (layer.type === 'symbol') {
      firstSymbolId = layer.id;
      break;
    }
  }

  // NSW
  if (!sourceExists(mapReference, 'nsw-bathymetry-source')) {
    mapReference.addSource('nsw-bathymetry-source', {
      type: 'raster',
      tiles: [
        'https://mapprod2.environment.nsw.gov.au/arcgis1041/rest/services/Coastal_Marine/NSW_Marine_Lidar_Bathymetry_Data_2018/MapServer/export?dpi=96&transparent=true&format=png32&layers=show%3A0%2C1%2C2&bboxSR=3857&imageSR=3857&width=256&height=256&f=image&bbox={bbox-epsg-3857}&',
      ],
      tileSize: 256,
    });
  }
  if (!layerExists(mapReference, 'wmsbathymetrynsw')) {
    mapReference.addLayer(
      {
        id: 'wmsbathymetrynsw',
        type: 'raster',
        source: 'nsw-bathymetry-source',
        layout: { visibility: 'none' },
        paint: {},
      },
      firstSymbolId,
    );
  }

  // WA
  if (!sourceExists(mapReference, 'wa-bathymetry-source')) {
    mapReference.addSource('wa-bathymetry-source', {
      type: 'raster',
      tiles: [
        'https://services.slip.wa.gov.au/public/rest/services/Landgate_Public_Maps/WA_Bathymetry/MapServer/export?transparent=true&format=TIFF&layers=show%3A2&bboxSR=3857&imageSR=3857&width=512&height=512&f=image&bbox={bbox-epsg-3857}&',
      ],
      tileSize: 512,
    });
  }
  if (!layerExists(mapReference, 'wmsbathymetrywa')) {
    mapReference.addLayer(
      {
        id: 'wmsbathymetrywa',
        type: 'raster',
        source: 'wa-bathymetry-source',
        layout: { visibility: 'none' },
        paint: {},
      },
      firstSymbolId,
    );
  }
};

const layer = {
  displayName: 'Bathymetry',
  synonyms: '',
  group: 'tileLayer',
  typeUrl: 'wmsbathymetry',
  shownByDefault: false,
  relativeDepth: 10,
  menuOptions: {
    visible: true,
    owningMenu: 'log-trips',
    order: 0,
  },
  icon: null,
};

layer.onToggle = (map, show) => {
  toggleLayerIfRequired(map, 'wmsbathymetrynsw', show);
  toggleLayerIfRequired(map, 'wmsbathymetrywa', show);
};

layer.onInitialize = (map) => {
  mapReference = map;
  addLayersIfRequired();
};

export default layer;
